var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-10"},[_vm._t("title",function(){return [_c('h4',[_vm._v(_vm._s(_vm.title))])]}),_c('v-divider',{staticClass:"mb-6"}),(_vm.intro)?_c('p',{staticClass:"pb-3"},[_vm._v(_vm._s(_vm.intro))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }